import React, { useState, useEffect } from 'react';
import { Table, Card, Button, Modal, Input, message, Tag } from 'antd';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';
import Cookies from 'js-cookie';

const ApprovalRecordTab = ({ object, recordId, setRecordData, functionRef, fetchRecordData }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState('Pending');
  const [comment, setComment] = useState('');
  const [approverId, setApproverId] = useState(null); // Store approver_user
  const [requestId, setRequestId] = useState(null); // Store request id
  const [isApproved, setIsApproved] = useState(false); // Track approval status
  const [loading, setLoading] = useState(false);
  const [myApprovalRequest, setMyApprovalRequest] = useState([]);
  const [allApprovals, setAllApprovals] = useState([]);

  const userId = Cookies.get('userId');


  useEffect(() => {
    if (recordId) {
      fetchApprovalById();
    }
  }, [recordId]);

  // New Function: fetchApprovalById
  const fetchApprovalById = async () => {
    setLoading(true);

    try {
      const apiService = new ApiService(
        `${BASE_URL}/approvals/record/${recordId}`,
        { "Content-Type": "application/json" },
        "GET"
      );

      const response = await apiService.makeCall();



      setAllApprovals(response);

      let currentApproval;
      response.forEach(res => {
        if (res.status === 'Pending' && res.approver_user?._id === userId) {
          currentApproval = res
        }
      });

      setMyApprovalRequest(currentApproval);

      if (currentApproval.status === 'Approved') {
        setIsApproved(true);  // Mark as approved using new name
      }

      if (Array.isArray(response) && response.length > 0) {
        const approverId = currentApproval.approver_user?._id || null;
        const requestId = currentApproval._id || null;
        setApproverId(approverId);
        setRequestId(requestId);

      } else {
        setApproverId(null);
      }

      // message.success("Approval details fetched successfully!");
    } catch (error) {
      // message.error("Error fetching approval details!");
      console.error("Error fetching approval details:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleAction = async (action) => {
    if (!requestId) {
      message.error("Request ID is not available!");
      return;
    }

    if (!comment) {
      message.error("Please add a comment before proceeding.");
      return;
    }

    setLoading(true);
    try {
      // Dynamically set the action in the endpoint
      const apiService = new ApiService(
        `${BASE_URL}/approvals/update/${requestId}`,
        { "Content-Type": "application/json" },
        "POST",
        {
          approval_request: {
            action: action,
            comment: comment.trim()
          }
        }
      );

      // Make the API call
      const response = await apiService.makeCall();

      message.success(`Request ${action === 'approve' ? 'approved' : 'rejected'} successfully!`);
      setApprovalStatus(action === 'approve' ? 'Approved' : 'Rejected');

      // Remove the resolved request from `allApprovals` and `myApprovalRequest`
      setAllApprovals((prevApprovals) =>
        prevApprovals.filter((approval) => approval._id !== requestId)
      );
      setMyApprovalRequest(null); // Clear the current approval

      // Optionally refresh record data after action
      // const recordUpdate = new ApiService(
      //   `${BASE_URL}/fetch_single_record/${object}/${recordId}`,
      //   { "Content-Type": "application/json" },
      //   "GET"
      // );

      // const responseData = await recordUpdate.makeCall();

      // setRecordData(responseData);



    } catch (error) {
      message.error(`Error performing the ${action} action : ${error.message}`);
      console.error(`Error performing the ${action} action:`, error);
    } finally {
      setLoading(false);
      setIsModalVisible(false);
      setComment('');
      fetchApprovalById();
      if (functionRef) {
        functionRef(); // Call the function when Component C mounts
      }
      fetchRecordData();
    }
  };


  // Data and columns for "All Approval Requests" table
  const tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Requested By',
      dataIndex: 'requestedBy',
      key: 'requestedBy',
    },
    {
      title: 'Assigned To',
      dataIndex: 'assignedTo',
      key: 'assignedTo',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Approved' ? 'green' : status === 'Rejected' ? 'red' : 'blue'}>
          {status}
        </Tag>
      ),
    },
    {
      title: 'Comments',
      dataIndex: 'comment',
      key: 'comment',
    },
  ];

  const tableData = allApprovals.map((req, index) => ({
    key: index + 1,
    name: req.step_name,
    requestedBy: req.requested_by?.Name,
    assignedTo: req.approver_user?.Name,
    status: req.status,
    comment: req.comment,
  }));

  const handleAcceptRejectClick = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setComment('');
  };


  return (
    <div style={{ padding: '16px' }}>
      {/* Section 1: All Approval Requests */}
      <div style={{ marginBottom: '24px' }}>
        <Card>
          <h2>All Approval Requests</h2>
          <Table columns={tableColumns} dataSource={tableData} pagination={{ pageSize: 5 }} />
        </Card>
      </div>

      {/* Section 2: My Approval Request */}
      <div>
        <Card>
          <h2>My Approval Request</h2>
          {loading ? (
            <p>Loading...</p> // Display a loading indicator while fetching data
          ) : myApprovalRequest && approverId === userId ? (
            <>
              <Card
                title={
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{myApprovalRequest?.step_name}</span>
                    <Button type="primary" onClick={handleAcceptRejectClick}>
                      Accept/Reject
                    </Button>
                  </div>
                }
              >
                <h2>Approval Request Details</h2>
                <p><strong>Name:</strong> {myApprovalRequest?.step_name}</p>
                <p><strong>Description:</strong> {myApprovalRequest?.description}</p>
                <p><strong>Requested By:</strong> {myApprovalRequest?.requested_by.Name}</p>
                <p><strong>Approval Status:</strong> {myApprovalRequest?.status}</p>
              </Card>
            </>

          ) : (
            <p>No approval requests assigned to you.</p> // Display when no requests are assigned
          )}
        </Card>

      </div>


      {/* Modal for Accept/Reject */}
      <Modal
        title={myApprovalRequest?.step_name}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        zIndex={1002}   // higher than sidebar
        centered
        width='40%'
      >
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="comment"><strong>Comment:</strong></label>
          <Input.TextArea
            id="comment"
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Add your comment here"
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <div>
            <Button
              type="primary"
              onClick={() => handleAction('approve')}
              style={{ marginRight: '8px' }}
              disabled={loading}
              loading={loading}
            >
              Approve
            </Button>
            <Button
              danger
              onClick={() => handleAction('reject')}
              disabled={loading}
              loading={loading}
            >
              Reject
            </Button>

          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ApprovalRecordTab;
